import React from 'react'
import { Field } from '@ztechapps/webui.form'
import { CheckboxInput } from '@ztechapps/webui.input'

/** The "Use as default" switch of a filter or pivot template — bound to the form's `isDefault`. */
export const UseAsDefaultSwitch = () => (
  <Field
    name="isDefault"
    label="Use as default"
    help="Loads automatically when this view opens."
    component={CheckboxInput}
    className="form-switch"
    onChange
  />
)
